import { Component, ElementRef, ViewContainerRef, ValueProvider, Renderer2, Injector, ChangeDetectionStrategy, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ComponentBase, IComponentBase, applyMixins, ComponentMixins, PropertyCollectionInfo, FormBase, setValue } from '@syncfusion/ej2-angular-base';
import { Calendar } from '@syncfusion/ej2-calendars';



export const /** @type {?} */ inputs: string[] = ['calendarMode','depth','enablePersistence','enableRtl','firstDayOfWeek','isMultiSelection','locale','max','min','showTodayButton','start','value','values','weekNumber'];
export const /** @type {?} */ outputs: string[] = ['focus', 'blur', 'change','created','destroyed','navigated','renderDayCell','valueChange','valuesChange'];
export const /** @type {?} */ twoWays: string[] = ['value', 'values'];
/**
 * Represents the Essential JS 2 Angular Calendar Component.
 * ```html
 * <ejs-calendar [value]='date'></ejs-calendar>
 * ```
 */
@ComponentMixins([ComponentBase, FormBase])
export class CalendarComponent extends Calendar implements IComponentBase {
public valueChange: any;
public valuesChange: any;
public focus: any;
public blur: any;
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];
        try {
                let mod = this.injector.get('CalendarsIslamic');
                if(this.injectedModules.indexOf(mod) === -1) {
                    this.injectedModules.push(mod)
                }
            } catch { }

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnChange(registerFunction: (_: any) => void): void {
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnTouched(registerFunction: () => void): void {
    }
/**
 * @param {?} value
 * @return {?}
 */
public writeValue(value: any): void {
    }
/**
 * @param {?} disabled
 * @return {?}
 */
public setDisabledState(disabled: boolean): void {
    }
/**
 * @return {?}
 */
public ngOnInit() {
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ejs-calendar',
    inputs: inputs,
    outputs: outputs,
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CalendarComponent),
            multi: true
        }
    ],
    queries: {

    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
}

function CalendarComponent_tsickle_Closure_declarations() {
/** @type {?} */
CalendarComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CalendarComponent.ctorParameters;
/** @type {?} */
CalendarComponent.prototype.valueChange;
/** @type {?} */
CalendarComponent.prototype.valuesChange;
/** @type {?} */
CalendarComponent.prototype.focus;
/** @type {?} */
CalendarComponent.prototype.blur;
/** @type {?} */
CalendarComponent.prototype.registerEvents;
/** @type {?} */
CalendarComponent.prototype.addTwoWay;
/** @type {?} */
CalendarComponent.prototype.ngEle;
/** @type {?} */
CalendarComponent.prototype.srenderer;
/** @type {?} */
CalendarComponent.prototype.viewContainerRef;
/** @type {?} */
CalendarComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
